import { useIntl } from 'react-intl';
import { Col, Form, FormInstance, Input, Row } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { CreateAreaRequest } from '@/core/domain/operational/Areas/Areas.types';
import React from 'react';
import { useDefaultMaxLengthFieldError } from '@/hooks';

interface Props {
  form: FormInstance<CreateAreaRequest>;
}

const AreasGeneralForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();

  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  const defaultEmptyFieldError = {
    required: true,
    message: intl.formatMessage({
      id: 'commons.form.errors.requiredField',
    }),
  };

  return (
    <Form form={form} name="areasGeneralForm">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8}>
          <FloatingFormItem
            name="name"
            rules={[defaultEmptyFieldError, defaultMaxLenghtFieldError(200)]}
            label={intl.formatMessage({
              id: 'areas.general.form.description',
            })}
          >
            <Input />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default AreasGeneralForm;
